import systemEventsApi from '@/pages/SystemEvents/systemEvents.api'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { useCallback, useEffect, useState } from 'react'
import notificationCenterConstants from '../notificationCenter.constants'

const useSystemEvents = () => {
  const { wait } = useHttpLoader()
  const [systemEvents, setSystemEvents] = useState<ISystemEvent[]>([])
  const [selectedEventTypes, setSelectedEventTypes] = useState<ISystemEvent['type'][]>(
    notificationCenterConstants.initSelectedEventType
  )
  const [loaded, setLoaded] = useState(false)

  const updateSystemEvents = useCallback(() => {
    systemEventsApi.list.abort()
    wait(systemEventsApi.list({ limit: 30, type__in: selectedEventTypes.join(',') }), (resp) => {
      if (resp.status === 'success') {
        setSystemEvents(resp.body.items)
        setLoaded(true)
      }
    })
  }, [selectedEventTypes])

  useEffect(() => {
    setLoaded(false)
    updateSystemEvents()
  }, [selectedEventTypes])

  return {
    systemEvents,
    updateSystemEvents,
    systemEventsLoading: !loaded,
    setSelectedEventTypes,
    selectedEventTypes,
  }
}

export default useSystemEvents
